import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaCeseActividadDirectaByID = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaCeseActividadDirectaByID = () => {
  const [loadingGetDeclaracionJuradaCeseActividadDirectaByID, setLoadingDeclaracionJuradaCeseActividadDirectaByID] = useState(false);
  const [successGetDeclaracionJuradaCeseActividadDirectaByID, setSuccessDeclaracionJuradaCeseActividadDirectaByID] = useState(false);
  const [errorGetDeclaracionJuradaCeseActividadDirectaByID, setErrorDeclaracionJuradaCeseActividadDirectaByID] = useState<any>(null);
  const [dataGetDeclaracionJuradaCeseActividadDirectaByID, setDataDeclaracionJuradaCeseActividadDirecta] = useState<any>(null);

  const [statusGetDeclaracionJuradaCeseActividadDirectaByID, setStatusGetDeclaracionJuradaCeseActividadDirectaByID] =
    useState<StatusGetDeclaracionJuradaCeseActividadDirectaByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaCeseActividadDirectaByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingDeclaracionJuradaCeseActividadDirectaByID(true);
    setSuccessDeclaracionJuradaCeseActividadDirectaByID(false);
    setErrorDeclaracionJuradaCeseActividadDirectaByID(null);

    try {
      const res = await apiRecord.getDeclaracionJuradaDirectaByID(userId, prestacionId, id);

      setStatusGetDeclaracionJuradaCeseActividadDirectaByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessDeclaracionJuradaCeseActividadDirectaByID(true);
      setDataDeclaracionJuradaCeseActividadDirecta(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaCeseActividadDirectaByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorDeclaracionJuradaCeseActividadDirectaByID(err);
      console.error("Error en getDeclaracionJuradaCeseActividadDirectaByID:", err);

      throw err;

    } finally {
      setLoadingDeclaracionJuradaCeseActividadDirectaByID(false);
    }
  };

  return {
    getDeclaracionJuradaCeseActividadDirectaByID,
    loadingGetDeclaracionJuradaCeseActividadDirectaByID,
    successGetDeclaracionJuradaCeseActividadDirectaByID,
    errorGetDeclaracionJuradaCeseActividadDirectaByID,
    dataGetDeclaracionJuradaCeseActividadDirectaByID,
    statusGetDeclaracionJuradaCeseActividadDirectaByID
  };
};

export default useGetDeclaracionJuradaCeseActividadDirectaByID;
